import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../components/ui/dialog";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { captureEmail, draftStore } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function EmailCaptureModal({ open, onOpenChange }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleContinue = async () => {
    if (!isValid) {
      toast.error("Please enter a valid email address");
      return;
    }
    setLoading(true);
    try {
      await captureEmail(email);
      draftStore.saveLeadEmail(email);
      const draft = draftStore.getDraft();
      draftStore.saveDraft({ ...draft, email });
      toast.success("Email saved — let's continue");
      onOpenChange(false);
      setTimeout(() => navigate("/inquiry"), 300);
    } catch (e) {
      toast.error("Couldn't save email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="dark-site sm:max-w-md rounded-2xl border-white/10" style={{ backgroundColor: "#10162a" }}>
        <DialogHeader>
          <DialogTitle className="text-2xl font-extrabold text-navy">
            What&apos;s your best email address?
          </DialogTitle>
          <DialogDescription className="text-gray-500">
            Drop your email so I know how to reach you. No spam, ever.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <Input
            type="email"
            placeholder="you@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleContinue()}
            className="h-12 text-base"
            autoFocus
          />
          <Button
            onClick={handleContinue}
            disabled={loading || !isValid}
            className="w-full h-12 bg-paul-yellow hover:bg-paul-yellow text-navy font-bold text-base disabled:opacity-60"
            style={{ color: "#0b1535" }}
          >
            {loading ? "Saving..." : "Continue"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
